import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Modal, Text } from "@quintoandar-tokko/jopijs";
import {
  modalContainer,
  contentContainer,
  saveButton,
} from "./modalWarning.module.scss";
import {
  setEditedData,
  setEditedDataBatch,
  setIsEdition,
  setShowModalEditionUnsaved,
  showToast,
} from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import Trans from "@/components/shared/Trans";
import translations from "../../FichaInfo.trans.json";
import cleanEditionData from "../../utilities/cleanEditedData";
import { saveProfileEdition } from "@/store/slices/components/fichaInfo/services";

function ModalWarning() {
  const dispatch = useDispatch();
  const {
    showModalEditionUnsaved,
    initialEditionData,
    edited_data,
    hash,
    TOKKO_HOST,
  } = useSelector((state) => state.FichaInfoSlice);

  const handleSave = () => {
    dispatch(setShowModalEditionUnsaved(false));
    dispatch(
      saveProfileEdition({
        data: cleanEditionData(edited_data),
        hash,
        TOKKO_HOST,
      })
    ).then((action) => {
      if (action.error) {
        dispatch(
          showToast({
            type: "danger",
            text: Trans(translations, "SavingError"),
          })
        );
      } else {
        dispatch(showToast({ text: Trans(translations, "ChangesSaved") }));
        dispatch(setIsEdition(false));
        dispatch(setEditedData({ key: "has_edition", value: true }));
      }
    });
  };

  const handleCancel = () => {
    dispatch(setEditedDataBatch(initialEditionData));
    dispatch(setIsEdition(false));
    dispatch(setShowModalEditionUnsaved(false));
  };

  return (
    showModalEditionUnsaved && (
      <Modal
        className={modalContainer}
        height="177px"
        maxWidth="439px"
        modalBG
        variant="center"
      >
        <Box className={contentContainer}>
          <Text lineHeight="21px" fontSize="14px" color="var(--colors-neutral-grey-800)">
            {Trans(translations, "ModalAdvertenceTitle")}
          </Text>
          <Modal.Header
            color="var(--colors-neutral-grey-800)"
            variant={["center"]}
            fontSize="14px"
            text={Trans(translations, "ModalAdvertenceQuestion")}
          />
        </Box>
        <Modal.Footer gap="24px" variant="center">
          <Button
            variant="primaryText"
            color="var(--colors-neutral-grey-800)"
            onClick={handleCancel}
          >
            {Trans(translations, "ModalAdvertenceDontSave")}
          </Button>
          <Button
            className={saveButton}
            variant={["primary", "medium"]}
            onClick={handleSave}
          >
            {Trans(translations, "Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default ModalWarning;
